import request from "@/utils/request";

export function getOperatingSummary(params) {
  return request({
    url: "/operation/getOperatingSummary",
    method: "get",
    params
  });
}

export function getOperatingDetails(params) {
  return request({
    url: "/operation/getOperatingDetails",
    method: "get",
    params
  });
}

export function getProductSales(params) {
  return request({
    url: "/operation/getProductSales",
    method: "get",
    params
  });
}

export function getMonthlySalesStatistics(params) {
  return request({
    url: "/operation/getMonthlySalesStatistics",
    method: "get",
    params
  });
}

export function getDailySalesTrends(params) {
  return request({
    url: "/operation/getDailySalesTrends",
    method: "get",
    params
  });
}
